export const HALF_OPTIONS = [
  { value: 'H1', label: 'H1' },
  { value: 'H2', label: 'H2' },
];

export const AUDIT_TYPE_OPTIONS = [
  { value: 'Internal', label: 'Internal Audit' },
  { value: 'External', label: 'External Audit' },
];

export const CONTROL_CATEGORY_OPTIONS = [
  { value: 'ITGC', label: 'ITGC' },
  { value: 'ITAC', label: 'ITAC' },
];

export const getFinancialYearOptions = () => {
  const now = new Date();
  const currentStartYear = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  const startYear = currentStartYear - 3;
  const years = [];

  for (let i = 0; i < 7; i += 1) {
    const year = startYear + i;
    years.push(`FY ${String(year).slice(-2)}-${String(year + 1).slice(-2)}`);
  }

  return years;
};

export const getCurrentFinancialYearLabel = (today = new Date()) => {
  const startYear = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
  return `FY ${String(startYear).slice(-2)}-${String(startYear + 1).slice(-2)}`;
};

export const getDefaultFinancialHalf = (today = new Date()) => {
  const month = today.getMonth() + 1;
  return month >= 4 && month <= 9 ? 'H1' : 'H2';
};

export const getFinancialHalfOptions = () => HALF_OPTIONS;

export const getStoredFinancialHalf = () => {
  const current = localStorage.getItem('financial_half');
  if (current) return current;
  const fallback = getDefaultFinancialHalf();
  localStorage.setItem('financial_half', fallback);
  return fallback;
};

export const getStoredFinancialYear = () => {
  const current = localStorage.getItem('financial_year');
  if (current) return current;
  const fallback = getCurrentFinancialYearLabel();
  localStorage.setItem('financial_year', fallback);
  return fallback;
};

export const setFinancialScope = (financialYear, financialHalf) => {
  localStorage.setItem('financial_year', financialYear);
  localStorage.setItem('financial_half', financialHalf);
};

export const getStoredAuditType = () => {
  const current = localStorage.getItem('audit_type');
  if (current === 'Internal' || current === 'External') return current;
  const fallback = 'Internal';
  localStorage.setItem('audit_type', fallback);
  return fallback;
};

export const setAuditType = (auditType) => {
  const normalized = auditType === 'External' ? 'External' : 'Internal';
  localStorage.setItem('audit_type', normalized);
};

export const getAuditTypeOptions = () => AUDIT_TYPE_OPTIONS;

export const getStoredControlCategory = () => {
  const current = localStorage.getItem('control_category');
  if (current === 'ITGC' || current === 'ITAC') return current;
  const fallback = 'ITGC';
  localStorage.setItem('control_category', fallback);
  return fallback;
};

export const setControlCategory = (controlCategory) => {
  const normalized = controlCategory === 'ITAC' ? 'ITAC' : 'ITGC';
  localStorage.setItem('control_category', normalized);
};

export const getControlCategoryOptions = () => CONTROL_CATEGORY_OPTIONS;

export const initializeFinancialScope = () => {
  const year = getStoredFinancialYear();
  const half = getStoredFinancialHalf();
  const auditType = getStoredAuditType();
  const controlCategory = getStoredControlCategory();
  setFinancialScope(year, half);
  setAuditType(auditType);
  setControlCategory(controlCategory);
  return { financialYear: year, financialHalf: half, auditType, controlCategory };
};

export const clearFinancialScope = () => {
  localStorage.removeItem('financial_year');
  localStorage.removeItem('financial_half');
  localStorage.removeItem('audit_type');
  localStorage.removeItem('control_category');
};
